<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="primary"
        pill
        @click="createUser"
        v-if="hasPermission('create_user')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Create</span>
      </b-button>
    </div>
    <b-card>
      <h1>User Management</h1>
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Name"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <b-form-input id="name" v-model="name" placeholder="Name" />
            </b-form-group>
            <b-form-group
              label="Username"
              label-for="username"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <b-form-input
                id="username"
                v-model="username"
                placeholder="Username"
              />
            </b-form-group>
            <b-form-group
              class="w-50"
              v-if="searchType.value === 3"
            >
              <VueSelectPaginated
                placeholder="Role"
                name="Role"
                label="name"
                rules="required"
                searchBy="name"
                :getListMethod="getRoles"
                @setMethod="
                  (value) => {
                    role = value;
                  }
                "
              />
            </b-form-group>

            <b-form-group
              label="Site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 4"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 5"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Floor"
              label-for="floor"
              class="w-50"
              v-if="searchType.value === 6"
            >
              <v-select
                label="name"
                v-model="floor"
                placeholder="Select Floor"
                :options="floors"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              class="w-50"
              v-if="searchType.value === 7"
            >
              <b-form-input id="email" type="email" v-model="email" placeholder="Email" />
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="users"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_user')"
        :per-page="0"
        :tbody-tr-class="rowClass"
      > 
        <template #cell(username)="row">
          <b-link @click="row.toggleDetails">
            {{
              row.item.username ? row.item.username : ""
            }}
          </b-link>
        </template>

        
        <template #cell(agent_name)="row">
          {{ row.item.agent_profile && row.item.agent_profile.full_name ? row.item.agent_profile.full_name : row.item.name || '-' }}
        </template>

        <template #cell(agent_email)="row">
          {{ row.item.agent_profile && row.item.agent_profile.business_email ? row.item.agent_profile.business_email : row.item.email || '-' }}
        </template>

        <template #cell(agent_phone)="row">
          {{ row.item.agent_profile && row.item.agent_profile.business_phone ? row.item.agent_profile.business_phone : row.item.mobile_number || '-' }}
        </template>

        <template #cell(role_data)="row">
          {{ row.item.role_data ? row.item.role_data.name : "" }}
        </template>        
        
        <template #cell(created_at)="row">
          {{ formatDate(row.item.created_at) }}
        </template>

        <template #cell(updated_at)="row">
          {{ formatDate(row.item.updated_at) }}
        </template>

        <template #cell(manage)="row">
          <b-button
            variant="primary"
            pill
            size="sm"
            class="mr-50"
            @click="editUser(row.item)"
            v-if="hasPermission('update_user')"
          >
            Edit
          </b-button>
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="approveUser(row.item)"
            v-if="hasPermission('update_user') && row.item.eligibility_status !== 'approved'"
          >
            <feather-icon icon="CheckIcon" class="mr-25" />
            Approve
          </b-button>

        </template>
      </b-table>
      <div class="row">
        <div class="col-md-11">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-1">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>
    </b-card>



    <CreateUserModal
      @modalClosed="onModalClosed"
      :key="`create-${createUserModalCount}`"
    />
    <EditUserModal
      :user="user"
      @modalClosed="onModalClosed"
      :key="`edit-${editUserModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateUserModal from "@/components/user/CreateUserModal.vue";
import EditUserModal from "@/components/user/EditUserModal.vue";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    CreateUserModal,
    EditUserModal,
    VueSelectPaginated,
    ToastificationContent,
  },
  data() {
    return {
      fields: [
        { key: "username", label: "Username" },
        { key: "agent_name", label: "Full Name" },
        { key: "agent_email", label: "Email" },
        { key: "agent_phone", label: "Contact Number" },
        { key: "role_data", label: "Role" },
        { key: "created_at", label: "Created" },
        { key: "updated_at", label: "Updated" },
        { key: "manage", label: "Manage" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      users: [],
      user: null,
      createUserModalCount: 0,
      editUserModalCount: 0,
      searchTypes: [
        { value: 1, name: "Name" },
        { value: 2, name: "Username" },
        { value: 3, name: "Role" },
        { value: 7, name: "Email" },
      ],
      searchType: null,
      name: "",
      username: "",
      role: "",
      email: "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
  },
  methods: {
    ...mapActions({
      getUsers: "appData/getUsers",
      deleteUser: "appData/deleteUser",
      updateUser: "appData/updateUser",
      approveUserAction: "appData/approveUser",
      getRoles: "appData/getRoles",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.username = "";
            this.role="";
            this.email="";
            break;
          case 2:
            this.name = "";
            this.role = "";
            this.email="";
            break;
          case 3:
            this.name = "";
            this.username = "";
            this.email="";
            break;
          case 4:
            this.name = "";
            this.username = "";
            this.role = "";
            break;
        }
      } else {
        this.name = "";
        this.username = "";
        this.role = "";
        this.email="";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getUsers({
          pageNumber: this.currentPage,
          name: this.name,
          username: this.username,
          role: this.role,
          site: this.site,        
          building: this.building,
          floor: this.floor,
          email: this.email,
        });
        this.users = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    
    createUser() {
      this.createUserModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-user-modal");
      });
    },
    editUser(user) {
      this.user = user;
      this.editUserModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-user-modal");
      });
    },
    async approveUser(user) {
      try {
        const res = await this.approveUserAction({ pk: user.id });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "User Approved Successfully",
                variant: "success",
                icon: "CheckCircleIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const d = new Date(dateString);
      return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    

    

    async removeUser(user) {
      this.user = user;
      try {
        const res = await this.deleteUser({
          pk: this.user.id,
        });
        if (res.status === 204) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "User deleted",
                variant: "success",
                icon: "CheckCircleIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
    
  },
  computed: {
    ...mapGetters({ hasPermission: "appData/hasPermission", getLoggedInUser: "appData/getLoggedInUser" },
    ),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style scoped>
.amber-background {
  background-color: #ffbf00 !important;
}
</style>

